﻿import { createSlice } from "@reduxjs/toolkit";

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: { userName: null, resetToken: null },
  reducers: {
    setUserAndToken: (state, action) => {
      const { userName, resetToken } = action.payload;
      state.userName = userName;
      state.resetToken = resetToken;
    },
    clearUserAndToken: (state, action) => {
      state.userName = null;
      state.resetToken = null;
    },
  },
});

export const { setUserAndToken, clearUserAndToken } =
  resetPasswordSlice.actions;
export const selectUser = (state) => state.tempInfo.resetPassword.userName;
export const selectResetToken = (state) =>
  state.tempInfo.resetPassword.resetToken;
export default resetPasswordSlice.reducer;
